import { actionTypes as navigationActionTypes } from 'actions/Navigation'

export const defaultState = {
  isDeployed: false,
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case navigationActionTypes.DOCK_SIDEBAR:
      return {
        ...state,
        isDeployed: false,
      }
    case navigationActionTypes.DEPLOY_SIDEBAR:
      return {
        ...state,
        isDeployed: true,
      }
    default:
      return state
  }
}
